<template>
  <v-card>
    <v-card-title class="headline">{{ cardTitle }}</v-card-title>
    <v-divider></v-divider>
    <v-container>
      <p v-if="action === 'delete'" class="title ml-3">Are you sure?</p>
      <v-form v-else>
        <v-menu ref="datePickerMenu" v-model="datePickerMenu" :close-on-content-click="false"
          :return-value.sync="pomodoro.date" transition="scale-transition" offset-y min-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field v-model="pomodoro.date" label="Date" prepend-icon="mdi-calendar" readonly v-on="on"
              :error-messages="formErrors.date"></v-text-field>
          </template>
          <v-date-picker v-model="pomodoro.date" no-title scrollable first-day-of-week="1" color="primary"
            @change="$refs.datePickerMenu.save(pomodoro.date)">
          </v-date-picker>
        </v-menu>

        <v-row>
          <v-col>
            <v-combobox v-model="pomodoro.task" :items="autocompleteTaskNames" label="Name"
              prepend-icon="mdi-format-letter-case" :error-messages="formErrors.task" clearable
              hide-no-data></v-combobox>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-select :items="pomodoroCategories" v-model="pomodoro.category" label="Category"
              prepend-icon="mdi-view-list" :error-messages="formErrors.category"></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field v-model="pomodoro.amount" label="Amount" prepend-icon="mdi-counter"
              :error-messages="formErrors.amount"></v-text-field>
          </v-col>
        </v-row>

        <v-alert v-if="formErrors.non_field_errors" type="error" text dense>{{
          formErrors.non_field_errors[0]
        }}</v-alert>
      </v-form>
    </v-container>
    <v-card-actions>
      <v-spacer />
      <v-btn text @click="closeDialog">Cancel</v-btn>
      <v-btn text :color="action === 'delete' ? 'error' : 'primary'" @click="submitForm"
        :loading="isWaitingForResponse">{{
          action === "delete" ? "delete" : "save" }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "PomodoroForm",

  props: {
    recordedDates: Array,
    action: {
      type: String,
      required: true,
      validator: function (value) {
        return ['create', 'edit', 'delete'].includes(value)
      }
    },
    propsPomodoro: {
      type: Object,
      default: function () {
        return {
          date: moment().format("YYYY-MM-DD"),
          task: "",
          category: "",
          amount: 1,
        }
      }
    }
  },

  data: function () {
    return {
      pomodoro: this.propsPomodoro,
      datePickerMenu: false,
      formErrors: {
      },
      isWaitingForResponse: false,
      pomodoroCategories: [
        { text: 'Work', value: 'work' },
        { text: 'Task', value: 'task' },
        { text: 'Health', value: 'health' },
        { text: 'Learning', value: 'learning' },
        { text: 'Reading', value: 'reading' },
        { text: 'Finances', value: 'finances' },
        { text: 'Other', value: 'other' },
      ],
    }
  },

  computed: {
    cardTitle: function () {
      const cardTitles = {
        "create": "New Pomodoro",
        "edit": "Edit Pomodoro",
        "delete": "Delete Pomodoro",
      }
      return cardTitles[this.action]
    },
    formData: function () {
      const formData = {
        date: this.pomodoro.date,
        task: this.pomodoro.task,
        category: this.pomodoro.category,
        amount: this.pomodoro.amount,
      }
      return formData
    },
    autocompleteTaskNames() {
      const twoWeeksAgo = new Date();
      twoWeeksAgo.setDate(twoWeeksAgo.getDate() - 14);
      const twoWeeksAgoStr = twoWeeksAgo.toISOString().split('T')[0];
      return [...new Set(
        this.$store.state.pomodoroSessions
          .filter(p => p.date >= twoWeeksAgoStr)
          .map(p => p.task)
      )].filter(Boolean);
    }
  },

  methods: {
    closeDialog: function () {
      this.$emit('close-dialog')
    },
    submitForm: function () {
      this.isWaitingForResponse = true
      const submitMethods = {
        "create": this.createPomodoro,
        "edit": this.editPomodoro,
        "delete": this.deletePomodoro
      }
      submitMethods[this.action]()
    },
    createPomodoro: function () {
      axios
        .post(
          `${process.env.VUE_APP_API_ROOT_URL}pomodoro/sessions/`,
          this.formData,
          this.$store.getters.axiosConfig
        )
        .then((response) => {
          this.$store.commit("createPomodoroSession", response.data)
          this.isWaitingForResponse = false
          this.closeDialog()
          this.$emit('createdPomodoro')
        })
        .catch(error => {
          this.formErrors = error.response.data
          this.isWaitingForResponse = false
        });
    },
    editPomodoro: function () {
      axios
        .put(
          `${process.env.VUE_APP_API_ROOT_URL}pomodoro/sessions/${this.pomodoro.id}/`,
          this.formData,
          this.$store.getters.axiosConfig
        )
        .then((response) => {
          this.$store.commit("updatePomodoroSession", response.data)
          this.isWaitingForResponse = false
          this.closeDialog()
        })
        .catch(error => {
          this.formErrors = error.response.data
          this.isWaitingForResponse = false
        });
    },
    deletePomodoro: function () {
      axios
        .delete(
          `${process.env.VUE_APP_API_ROOT_URL}pomodoro/sessions/${this.pomodoro.id}/`,
          this.$store.getters.axiosConfig
        )
        .then(() => {
          this.$store.commit("deletePomodoroSession", this.pomodoro)
          this.isWaitingForResponse = false
          this.closeDialog()
        })
        .catch(() => {
          this.isWaitingForResponse = false
        });
    }
  },


}
</script>